import { useDisclosure } from '@chakra-ui/react'

import { useInterview } from '@/react-query/interview/interview'
import { useUser } from '@/react-query/user'
import { useAudioRecorder } from '@/views/screens/Interview/context/AudioRecorderContext/AudioRecorderContext'

import { MicPrestartModal } from '../components/MicPrestartModal'
import { TabPrestartModal } from '../components/TabPrestartModal'

export const useRecordingModals = () => {
  const user = useUser()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    isOpen: isTabDisclosureOpen,
    onOpen: onTabDisclosureOpen,
    onClose: onTabDisclosureClose,
  } = useDisclosure()
  const { startMicrophoneRecording, startTabRecording } = useAudioRecorder()
  const interviewId = useInterview().data?.id || ''

  const handleMicClick = user.data?.showLiveRecordingPopup
    ? onOpen
    : () => startMicrophoneRecording()

  const handleTabClick =
    user.data?.showTabLiveRecordingPopup !== false
      ? onTabDisclosureOpen
      : () => startTabRecording()

  const ModalComponent = (
    <>
      <MicPrestartModal
        isOpen={isOpen}
        onClose={onClose}
        startRecording={() => startMicrophoneRecording()}
      />
      <TabPrestartModal
        isOpen={isTabDisclosureOpen}
        onClose={onTabDisclosureClose}
        startRecordingWithTab={() => startTabRecording()}
      />
    </>
  )

  return {
    ModalComponent,
    handleMicClick,
    handleTabClick,
  }
}
